import { render, staticRenderFns } from "./minimarkDown.vue?vue&type=template&id=2fc57132&scoped=true"
import script from "./minimarkDown.vue?vue&type=script&lang=js"
export * from "./minimarkDown.vue?vue&type=script&lang=js"
import style0 from "./minimarkDown.vue?vue&type=style&index=0&id=2fc57132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc57132",
  null
  
)

export default component.exports